export default "__VITE_PUBLIC_ASSET__65f525ed__"